module.exports = __webpack_public_path__ + "img/cineself-app-screens.1e92d2e0.png";